import {
    INSTITUTIONS_DETAILS_REQUEST,
    INSTITUTIONS_DETAILS_SUCCESS,
    INSTITUTIONS_DETAILS_FAILURE,
    INSTITUTIONS_LIST_REQUEST,
    INSTITUTIONS_LIST_SUCCESS,
    INSTITUTIONS_LIST_FAILURE,
    SET_INSTITUTIONS_SEARCH_CRITERIA,
    TOGGLE_DRAWER_MOBILE_FILTER_SEARCH,
    INSTITUTIONS_TYPES_REQUEST,
    INSTITUTIONS_TYPES_SUCCESS,
    INSTITUTIONS_TYPES_FAILURE,
    INSTITUTIONS_DROPDOWN_REQUEST,
    INSTITUTIONS_DROPDOWN_SUCCESS,
    INSTITUTIONS_DROPDOWN_FAILURE,
    GET_INSTITUTIONS_AGES_REQUEST,
    GET_INSTITUTIONS_AGES_SUCCESS,
    GET_INSTITUTIONS_AGES_FAILURE,
} from './types';

const initialState = {
    // Détails institution
    institutionsDetails: {},
    institutionsDetailsLoading: false,
    institutionsDetailsErrors: {},

    // Liste des institutions
    institutionsList: [],
    institutionsListLoading: false,
    institutionsListErrors: {},

    // Taxonomies / types
    types: [],
    taxonomiesLoading: false,
    taxonomiesErrors: {},

    // taxonomie ages
    ages: [],
    agesLoading: false,

    // Dropdown institutions
    institutionsDropdown: [],
    institutionsDropdownLoading: false,
    institutionsDropdownErrors: {},

    // Critères de recherche
    search: { type: '', selectedInstitution: '', age: '' },
    drawerMobileFilterSearchOpen: false,

    // Listing des institutions
    institutions: [],
    institutionsLoading: false,
    totalFuture: '',

    // Pagination
    hasMore: false,
    currentPage: 1,
    newSearch: false,
    fakeLoadingTime: 0,
};

export default function institutionsReducer(state = initialState, action) {
    switch (action.type) {
        // --- Détails ---
        case INSTITUTIONS_DETAILS_REQUEST:
            return { ...state, institutionsDetailsLoading: true };
        case INSTITUTIONS_DETAILS_SUCCESS:
            return { ...state, institutionsDetailsLoading: false, institutionsDetails: action.payload || {}, institutionsDetailsErrors: {} };
        case INSTITUTIONS_DETAILS_FAILURE:
            return { ...state, institutionsDetailsLoading: false, institutionsDetails: {}, institutionsDetailsErrors: action.payload || {} };

        // --- Liste ---
        case INSTITUTIONS_LIST_REQUEST:
            return { ...state, institutionsListLoading: true };
        case INSTITUTIONS_LIST_SUCCESS:
            const list = action.newSearch ? action.payload.posts || [] : [...state.institutionsList, ...(action.payload.posts || [])];
            return { ...state, institutionsListLoading: false, institutionsList: list, institutionsListErrors: {}, hasMore: action.payload.hasMore || false, currentPage: action.page || 1, fakeLoadingTime: action.fakeLoadingTime || 0 };
        case INSTITUTIONS_LIST_FAILURE:
            return { ...state, institutionsListLoading: false, institutionsList: [], institutionsListErrors: action.payload || {} };

        // --- Taxonomies ---
        case INSTITUTIONS_TYPES_REQUEST:
            return { ...state, taxonomiesLoading: true, taxonomiesErrors: {} };
        case INSTITUTIONS_TYPES_SUCCESS:
            return { ...state, taxonomiesLoading: false, types: action.payload || [], taxonomiesErrors: {} };
        case INSTITUTIONS_TYPES_FAILURE:
            return { ...state, taxonomiesLoading: false, types: [], taxonomiesErrors: action.payload || {} };

        // --- Dropdown ---
        case INSTITUTIONS_DROPDOWN_REQUEST:
            return { ...state, institutionsDropdownLoading: true, institutionsDropdownErrors: {} };
        case INSTITUTIONS_DROPDOWN_SUCCESS:
            return { ...state, institutionsDropdownLoading: false, institutionsDropdown: action.payload || [], institutionsDropdownErrors: {} };
        case INSTITUTIONS_DROPDOWN_FAILURE:
            return { ...state, institutionsDropdownLoading: false, institutionsDropdown: [], institutionsDropdownErrors: action.payload || {} };

        // --- Ages ---
        case GET_INSTITUTIONS_AGES_REQUEST:
            return {
                ...state,
                agesLoading: true,
                error: null,
            };

        case GET_INSTITUTIONS_AGES_SUCCESS:
            return {
                ...state,
                agesLoading: false,
                ages: Array.isArray(action.payload) ? action.payload : [],
            };

        case GET_INSTITUTIONS_AGES_FAILURE:
            return {
                ...state,
                agesLoading: false,
                error: action.error,
            };

        // --- Critères de recherche ---
        case SET_INSTITUTIONS_SEARCH_CRITERIA:
            return {
                ...state,
                search: {
                    type: action.payload.type || '',
                    selectedInstitution: action.payload.selectedInstitution || '',
                    age: action.payload.age || '',
                },
            };

        // --- Drawer ---
        case TOGGLE_DRAWER_MOBILE_FILTER_SEARCH:
            return { ...state, drawerMobileFilterSearchOpen: !state.drawerMobileFilterSearchOpen };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/features/Institutions/reducers.js